
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import MenuContent from "./components/MenuContent.vue";

export default defineComponent({
  name: "MenuPage",
  components: {
    BreadCrumb,
    MenuContent,
  },
});
